export const ItemTypes = {
  PLAY: "play",
};

export interface DragItem {
  index: number;
  id: string;
  type: string;
}
